import { types } from "mobx-state-tree"
import { DictionaryLink } from "modules/common/models/dictionary-link"
import { StringifiedOrderLink } from "modules/orders-manage/models/order-link"

/**
 * Карточка доски. Комментарии, файлы и тексты в неё не входят: они приходят,
 * когда задание открывают
 */
export const QuestionCard = types
  .model({
    id: types.string,
    number: types.optional(types.string, ""),
    title: types.optional(types.string, ""),
    orderId: types.optional(types.string, ""),
    order: types.maybeNull(StringifiedOrderLink),
    stopDate: types.optional(types.string, ""),
    stopDay: types.optional(types.string, ""),
    completed: types.optional(types.boolean, false),
    columnId: types.optional(types.string, ""),
    sortOrder: types.optional(types.number, 0),
    portfolioId: types.optional(types.string, ""),
    authorId: types.optional(types.string, ""),
    employers: types.array(DictionaryLink),
    implementers: types.array(DictionaryLink),
    tags: types.array(types.string),
    messagesCount: types.optional(types.number, 0),
    filesCount: types.optional(types.number, 0),
    childrenCount: types.optional(types.number, 0),
    /** Сколько исполнителей отметили готовность и сколько должны */
    readyCount: types.optional(types.number, 0),
    executorsCount: types.optional(types.number, 0),
    canMoveQuestion: types.optional(types.boolean, false),
    canCompleteQuestion: types.optional(types.boolean, false),
    /** Можно править задание: срок, проект, метки, текст */
    canEditQuestion: types.optional(types.boolean, false),
    canRemoveQuestion: types.optional(types.boolean, false),
    /** Можно отправить задание на другую доску */
    canMoveToBoard: types.optional(types.boolean, false),
    /** Можно отметить выполнение сразу за всех исполнителей */
    canManageReadiness: types.optional(types.boolean, false),
    /** Задание выполняет сам пользователь */
    isExecutor: types.optional(types.boolean, false),
    /** Он уже отметил свою готовность */
    ownReady: types.optional(types.boolean, false),
  })
  .views((self) => ({
    /** Заголовок карточки: у старых заданий его нет, показываем номер */
    get label() {
      return self.title || `Задание ${self.number}`
    },
  }))
  .named("QuestionCard")

/**
 * Загруженный кусок колонки. Карточек в колонке может быть много, поэтому доска
 * держит только показанные и знает, сколько их всего
 */
export const ColumnPage = types
  .model({
    columnKey: types.string,
    total: types.optional(types.number, 0),
    items: types.array(QuestionCard),
    loading: types.optional(types.boolean, false),
  })
  .views((self) => ({
    /** Есть ли что подгружать */
    get hasMore() {
      return self.items.length < self.total
    },
  }))
  .named("ColumnPage")

export type QuestionCardType = typeof QuestionCard.Type
export type QuestionCardSnapshotType = typeof QuestionCard.SnapshotType
export type ColumnPageType = typeof ColumnPage.Type
export type ColumnPageSnapshotType = typeof ColumnPage.SnapshotType

/** Ответ /orders/question-board/cards */
export interface QuestionCardsPage {
  columns: {
    columnKey: string
    total: number
    items: QuestionCardSnapshotType[]
  }[]
}

/** Подзадание в окне переноса на другую доску */
export interface QuestionChild {
  id: string
  number: string
  title: string
  stopDay: string
  completed: boolean
}

/** Сколько карточек в странице колонки. Совпадает с GetQuestionCardsQuery.PageSize */
export const PAGE_SIZE = 15
